import BaseModel from 'models/base-model';
import { STATEMENT_STATUS } from 'constants/feature/statement-list-constants';
import { AUTO_TIEOUT_COMPARE_MODE_CANCELLED } from 'constants/feature/statement-content-constants';
import { isNullOrUndefined } from 'utils/object-utils';
export default class LinkedStatement extends BaseModel({
  clientId: null,
  clientName: '',
  statementId: null,
  statementName: '',
  revisionId: null,
  revisionNumber: null,
  workpaperId: null,
  referenceNumber: '',
  documentProcessType: null,
  statementStatus: null,
  workflowStatus: null,
  initiatorId: null,
  processedDate: null,
}) {
  get isStatementDeleted() {
    return (
      this.statementStatus === STATEMENT_STATUS.DELETED ||
      this.statementStatus === STATEMENT_STATUS.HARD_DELETED
    );
  }

  get isStatementNameNotFound() {
    return isNullOrUndefined(this.statementName);
  }

  get isStatementStatusNotFound() {
    return isNullOrUndefined(this.statementStatus);
  }

  get isWorkflowStatusCancelled() {
    return this.workflowStatus === AUTO_TIEOUT_COMPARE_MODE_CANCELLED;
  }
}
